/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：241
 */

"use strict"

module.exports = require(/* 1578 */"./1578")
